import {createSelector} from 'reselect';
import {State} from '../../../../types/mx/reducers';
import * as MenuConstants from '../../../common/constants/MenuConstants';
import {POS_FROM_WIZARD_TYPE} from '../../../common/constants/LabelConstants';

export const isOnlineSelector = createSelector(
    (state: State) => state.commonLoanApplication.pos.posData?.type,
    (posDataType) => posDataType === POS_FROM_WIZARD_TYPE,
);

export const menuSelector = createSelector(
    (state: State) => state.creditoReal.menu.menu,
    (state: State) => state.admin.profile.roles,
    isOnlineSelector,
    (menus, roles, isOnline) =>
        menus
            .filter(
                (menu) =>
                    !menu.allowedRoles ||
                    menu.allowedRoles.length === 0 ||
                    (menu.allowedRoles?.length > 0 &&
                        menu.allowedRoles.some((role) => roles.includes(role))),
            )
            .map((menu) => ({
                ...menu,
                items: menu.items.filter((item) => {
                    const isOnlinePreviewBankAccount: boolean =
                        isOnline &&
                        item.id === MenuConstants.PREVIEW_BANK_ACCOUNT;
                    return (
                        item.allowedRoles.find((role) =>
                            roles.includes(role),
                        ) && !isOnlinePreviewBankAccount
                    );
                }),
            })),
);
